// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__7jB5I","info":"Note_info__2XZGW","note":"Note_note__PwQjP","actions":"Note_actions__2ZuoY"};